import { Divider } from '@tribeplatform/react-ui-kit/Divider';
export const DividerBlock = Divider;
//# sourceMappingURL=Block.js.map